export enum researchStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  REQUEST = 'REQUEST',
  APPROVED = 'APPROVED',
  REVISION = 'REVISION',
  REJECTED = 'REJECTED',
  DEFAULT = ''
}
